import React from 'react';
import { useController } from 'react-hook-form';
import { Form, CurrencyInput } from '@weezevent/nacre';
import { FieldErrorMessage } from '../FieldErrorMessage';
import PropTypes from 'prop-types';

export const FormCurrencyInput = ({ name, label, disabled = false, required = false, ...rest }) => {
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({
        name
    });

    return (
        <Form.Field>
            <Form.Label for={name} label={label} required={required} />
            <CurrencyInput
                errors={!!error}
                id={name}
                value={value}
                onChange={({ value }) => {
                    onChange(value);
                }}
                disabled={disabled}
                {...rest}
            />
            <FieldErrorMessage error={error} />
        </Form.Field>
    );
};

FormCurrencyInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    required: PropTypes.bool
};
